import * as React from "react";
const SvgHeaderRound = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 375 44", preserveAspectRatio: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M375.019-.944.023-.918 0 27.985c-.007 8.553 83.947 15.486 187.5 15.486S375 36.538 375 27.985l-.001-.044H375Z", style: {
  fill: "#00214d"
} }));
export default SvgHeaderRound;
